export enum SettingType {

    CUSTOMER_MODE = 'CustomerMode',
    IS_LOCK_ENABLE = 'IsLockEnable',
    PRINT_MOVE_TABLE = 'PrintMoveTable',
    // RUNNING_NUMBER = 'runningNumber',
    SMS_REPORT = 'SmsReport',
    USE_JOB = 'UseJob',
    // Combo-set (product-set) feature flag. Legacy: config.js reads
    // getValueOf('UseComboSet'); Views/Menu/Index.cshtml shows the combo tab when
    // it == 'true'. Gates the Menu → Combo editor tab in the new SPA.
    USE_COMBO_SET = 'UseComboSet',
    VOID_ON_MOBILE = 'VoidOnMobile',
    PRINT_PREVIEW_REMOTE = 'PrintPreviewRemote',
    SHOP_NAME = 'ShopName',
    // Room Service feature flag. Legacy: config.js reads getValueOf('RoomEnable');
    // Views/Pos/partial/payment.cshtml shows the Room text input when enabled and
    // stamps the receipt with Order.Room. Gates the Room input in the payment modal.
    ROOM_ENABLE = 'RoomEnable',
    // Show the per-line item discount on the printed receipt / bill.
    // Missing => off. Only the string 'true' (or '1') turns it on.
    SHOW_ITEM_DISCOUNT = 'ShowItemDiscount',
    // Print each item's price on the KITCHEN slip (system env "PrintShowPrice").
    // Port of legacy thermalprinter.v2.js `isShowPrice`. Admin-backend only —
    // there is deliberately no POS-side UI. Missing => off; only 'true' / '1' turns it on.
    PRINT_SHOW_PRICE = 'PrintShowPrice',
    NO_ROUND_UP = 'NoRoundUp',     // ใช้ชื่อนี้ได้เลยครับ แม้มันจะงงหน่อย* มองเป็นแค่ string ที่เก็บค่า rounding mode
    BILLING_PATTERN = 'BillingPattern'
}